import { render, staticRenderFns } from "./recordForm.vue?vue&type=template&id=6e95c920&scoped=true"
import script from "./recordForm.vue?vue&type=script&lang=js"
export * from "./recordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e95c920",
  null
  
)

export default component.exports